export default function Instructions() {

    return (
        
        <section className = "paper wrapper" id="instructions" >
            <div className="text">
                <h2>Instructions</h2>
                <ol>
                    <li>Press the start button. The timer will immediately start ticking backwards from 20 seconds.</li>
                    <li>Click on a yellow shape on the tray on the right and drag the shape to it’s matching shape on the left.  Once the yellow shape is over it’s matching shape, let go of the mouse and the shape will drop into place.</li>
                    <li>Sort all shapes before the time is up!</li>
                </ol>
            </div>
            <div className="lines"></div>
        </section>

    )
}